import { Ban, CheckCircle2, Lock } from "lucide-react";

import type { TaxClosingPeriodItem } from "@/services/tax-closing-period";
import type { MonthStats, MonthView } from "./types";

export const TAX_CLOSING_PERIOD_STATUS = {
  RELEASED: "RELEASED",
  BLOCKED: "BLOCKED",
  CLOSED: "CLOSED",
} as const;

export type TaxClosingPeriodStatus = TaxClosingPeriodItem["status"];

export const TAX_CLOSING_PERIOD_VIEW_KIND = {
  REAL: "real",
  PLACEHOLDER: "placeholder",
} as const;

export const TAX_CLOSING_PERIOD_CELL_KIND = {
  ...TAX_CLOSING_PERIOD_STATUS,
  PLACEHOLDER: "PLACEHOLDER",
  FUTURE: "FUTURE",
} as const;

export type TaxClosingPeriodCellKind =
  | TaxClosingPeriodStatus
  | typeof TAX_CLOSING_PERIOD_CELL_KIND.PLACEHOLDER
  | typeof TAX_CLOSING_PERIOD_CELL_KIND.FUTURE;

export const MONTH_STAT_KEY_BY_STATUS: Record<
  TaxClosingPeriodStatus,
  keyof MonthStats
> = {
  [TAX_CLOSING_PERIOD_STATUS.RELEASED]: "released",
  [TAX_CLOSING_PERIOD_STATUS.BLOCKED]: "blocked",
  [TAX_CLOSING_PERIOD_STATUS.CLOSED]: "closed",
};

export const MONTH_STAT_KEY_BY_VIEW_KIND: Record<MonthView["kind"], keyof MonthStats> = {
  [TAX_CLOSING_PERIOD_VIEW_KIND.REAL]: "released",
  [TAX_CLOSING_PERIOD_VIEW_KIND.PLACEHOLDER]: "placeholder",
};

export const PERIOD_STATUS_LABELS: Record<TaxClosingPeriodStatus, string> = {
  [TAX_CLOSING_PERIOD_STATUS.RELEASED]: "Liberado",
  [TAX_CLOSING_PERIOD_STATUS.BLOCKED]: "Bloqueado",
  [TAX_CLOSING_PERIOD_STATUS.CLOSED]: "Fechado",
};

export const PERIOD_STATUS_ICON = {
  [TAX_CLOSING_PERIOD_STATUS.RELEASED]: CheckCircle2,
  [TAX_CLOSING_PERIOD_STATUS.BLOCKED]: Ban,
  [TAX_CLOSING_PERIOD_STATUS.CLOSED]: Lock,
} as const;
